module.exports = __webpack_public_path__ + "img/result.88dafeaf.png";